var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("top", {
        attrs: { user: _vm.user, collapse: _vm.collapse, maxPage: _vm.maxPage },
      }),
      _vm._v(" "),
      _vm.permissions.length > 0
        ? _c("navbar", {
            attrs: {
              permissions: _vm.permissions,
              collapse: _vm.collapse,
              maxPage: _vm.maxPage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          class:
            _vm.maxPage || _vm.permissions.length == 0 ? "content-max" : "",
        },
        [
          _vm.next
            ? _c("router-view", { key: _vm.$route.fullPath })
            : _c(
                "div",
                [_c("v-progress-linear", { attrs: { indeterminate: "" } })],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("button-tags"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }